<template>
    <div class="auctions-shop-tab container d-flex align-items-stretch h-100">
        <div class="d-flex flex-column w-100">
            <div v-if="config.auctionEnabled" class="row pl-4 pr-4 mb-3">
                <div class="col-6 col-md-3 offset-md-3 pr-1">
                    <b-button @click="currentTab = 'auctions';btnSfx();" size="lg" class="px-3" block :variant="currentTab == 'auctions' ? 'tab' : 'outline-tab'">
                        {{ $t('home.home_sa_tab_auctions') }}
                    </b-button>
                </div>
                <div class="col-6 col-md-3 pl-1">
                    <b-button @click="currentTab = 'shop';btnSfx();" size="lg" class="px-3" block :variant="currentTab == 'shop' ? 'tab' : 'outline-tab'">
                        {{ $t('home.home_sa_tab_shop') }}
                    </b-button>
                </div>
            </div>
            <transition name="fade" mode="out-in">
                <auctions-tab v-if="currentTab == 'auctions'" :tab="0"></auctions-tab>
                <shop-tab v-if="currentTab == 'shop'"></shop-tab>
            </transition>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

import AuctionsTab from '../components/auctions/AuctionsTab.vue';
import ShopTab from '../components/shop/ShopTab.vue';

const AuctionsShopTab = Vue.component('auctions-shop-tab', {
    component: {AuctionsTab,ShopTab},
    props: {
        tab: String,
    },

    data(){
        return {
            currentTab: 'auctions'
        };
    },

    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },
        config(){
            return this.$store.state.config.data;
        }
    },

    created(){
        if(this.config.auctionEnabled)
            this.currentTab = this.tab;
        else
            this.currentTab = "shop";
    },

    mounted(){
        this.$store.dispatch('sound/bg','BG_Shop');
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
    },

    watch: {
        tab(){
            this.currentTab = this.tab;
        }
    }
});

export default AuctionsShopTab
</script>
